<template>
  <div class="content">
    <!--  -->
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
            <el-breadcrumb-item>人员信息</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <!-- 侧边树 -->
      <el-aside width="15%" style="height:100%" class="aside">
        <el-card style="height:100%;overflow-y: auto;">
          <el-tree
              :data="dataTree"
              ref="tree"
              :props="defaultProps"
              default-expand-all
              :expand-on-click-node="false"
              node-key="id"
              highlight-current
              :current-node-key="currentNodekey"
              :default-expanded-keys="expandedkeys"
              @node-click="handleNodeClick"
          ></el-tree>
        </el-card>
      </el-aside>
      <!-- 右边 -->
      <el-main
          class="build-CURD"
          style="height: 100%;padding:0px !important; padding-left: 20px !important; position: relative;width: 84%;"
      >
        <div class="box-card box-card_right" style="height:100%;padding:0px;">
          <div style="width:100%;min-height:10vh;position: relative;background:#fff;">
            <div v-if="search.teamsType=='1'" class="gongzhong" :class="(show?'':'gzAuto')">
              <p style="width:8vw;height:5vh;display: inline-block;float: left;padding-top: 1.5vh;text-align:right;">
                工种：</p>
              <div style="width:calc( 100% - 13vw );position: relative;height: auto;min-height: 6vh;float: left;">
                <span v-for="(item,index) in workerType" :key="index" class="type-item"
                      style="height: 3vh;margin-top: 1.5vh;display: inline-block;float:left;"
                      :class="(search.workType==item.value?'selIndex':'')"
                      @click="subWorkType(item)">{{ item.label }}</span>
              </div>
              <p style="width:5vw;height:100%;display: inline-block;float: left;padding-top:1.2vh;cursor: pointer;"
                 @click="show=!show">
                <i v-if="show" class="el-icon-arrow-down"></i><i v-else class="el-icon-arrow-up"></i>展开
              </p>
            </div>
            <div v-else-if="search.teamsType=='2'" class="gongzhong" :class="(show?'':'gzAuto')">
              <p style="width:8vw;height:5vh;display: inline-block;float: left;padding-top: 1.5vh;text-align: right;">
                岗位：</p>
              <div style="width:calc( 100% - 13vw );position: relative;height: auto;min-height: 6vh;float: left;">
                <span v-for="(item,index) in managerType" :key="index" class="type-item"
                      style="height: 3vh;margin-top: 1.5vh;display: inline-block;float:left;"
                      :class="(search.workType==item.value?'selIndex':'')"
                      @click="subWorkType(item)">{{ item.label }}</span>
              </div>
              <p style="width:5vw;height:100%;display: inline-block;float: left;padding-top:1.2vh;cursor: pointer;"
                 @click="show=!show">
                <i v-if="show" class="el-icon-arrow-down"></i><i v-else class="el-icon-arrow-up"></i>展开
              </p>
            </div>
            <div v-else-if="search.teamsType=='3'" class="gongzhong" :class="(show?'':'gzAuto')">
              <p style="width:8vw;height:5vh;display: inline-block;float: left;padding-top: 1.5vh;text-align: right;">
                特殊工种：</p>
              <div style="width:calc( 100% - 13vw );position: relative;height: auto;min-height: 6vh;float: left;">
                <span v-for="(item,index) in specialType" :key="index" class="type-item"
                      style="height: 3vh;margin-top: 1.5vh;display: inline-block;float:left;"
                      :class="(search.workType==item.value?'selIndex':'')"
                      @click="subWorkType(item)">{{ item.label }}</span>
              </div>
              <p style="width:5vw;height:100%;display: inline-block;float: left;padding-top:1.2vh;cursor: pointer;"
                 @click="show=!show">
                <i v-if="show" class="el-icon-arrow-down"></i><i v-else class="el-icon-arrow-up"></i>展开
              </p>
            </div>
            <div
                style="width:100%;height:6vh;position: relative;border-bottom: 1px dashed rgb(239 233 233);display:flex;align-items: center;">
              <p style="width:8vw;height:5vh;display:flex;justify-content: flex-end;align-items: center;">工人状态：</p>
              <div
                  style="width:calc( 100% - 8vw );display:flex;flex-wrap:wrap;justify-content: flex-start;align-content: flex-start;">
                <p class="type-item" :class="(search.personStatus==''?'selIndex':'')" @click="statusSearch()"
                   style="margin:0 1vw 0 0;">不限</p>
                <p class="type-item" :class="(search.personStatus=='2'?'selIndex':'')" @click="statusSearch('2')"
                   style="margin:0 1vw 0 0;">未分配</p>
                <p class="type-item" :class="(search.personStatus=='0'?'selIndex':'')" @click="statusSearch('0')"
                   style="margin:0 1vw 0 0;">在职</p>
                <p class="type-item" :class="(search.personStatus=='1'?'selIndex':'')" @click="statusSearch('1')"
                   style="margin:0 1vw 0 0;">离职</p>
              </div>
            </div>
            <div
                style="width:100%;height:6vh;position: relative;border-bottom: 1px dashed rgb(239 233 233);display:flex;align-items: center;justify-content: space-between;padding-right:1vw;">
              <div style="display: flex;align-items: center;width:80%;">
                <p style="width:8vw;height:5vh;display:flex;justify-content: flex-end;align-items: center;">姓名：</p>
                <el-input v-model="search.name" clearable placeholder="请输入姓名"></el-input>
                <p style="width:8vw;height:5vh;margin-left:1vw;display:flex;justify-content: flex-end;align-items: center;">
                  身份证号：</p>
                <el-input v-model="search.idCard" clearable placeholder="请输入身份证号"></el-input>
                <p style="width:8vw;height:5vh;margin-left:1vw;display:flex;justify-content: flex-end;align-items: center;">
                  排序方式：</p>
                <el-select v-model="search.sort" placeholder="请选择" @change="doFilter">
                  <el-option label="默认" value="0"></el-option>
                  <el-option label="人员名称" value="1"></el-option>
                  <el-option label="入职时间" value="2"></el-option>
                  <el-option label="参建单位" value="3"></el-option>
                </el-select>
              </div>
              <div>
                <el-button type="primary" plain @click="doFilter">查询</el-button>
              </div>
            </div>
          </div>
          <div
              style="width:100%;height:5vh;position: relative;background:#ecf0f5;padding:0 10px;text-align: right;display: flex;align-items: center;justify-content: space-between;">
            <div>
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange(listData)">
                全选
              </el-checkbox>
              <span style="margin-left:1vw;font-size:14px;">共 {{ this.totalItems }} 条记录</span>
            </div>
            <div style="width:auto;display:flex;">
              <!-- <div v-if="search.teamsId!=''" class="self-btn">入职导入<img src="../../assets/image/icon/excel.png"  /></div> -->
              <el-upload
                  v-if="search.teamsId!=''"
                  class="upload-demo"
                  ref="upload"
                  :action="uploadUrl"
                  :headers="uploadHead"
                  :disabled="isCursor=='wait'"
                  :data="uploadData"
                  :before-upload="beforeAvatarUpload"
                  :on-success="handleAvatarSuccess"
                  :show-file-list="false">
                <!-- <el-button type="primary" size="mini">入职导入<img src="../../assets/image/icon/excel1.png" style="height:12px;top:1px;margin-left: 2px;" /></el-button> -->
                <el-dropdown>
                  <p class="btn-item" style="margin-top: 0.5vh;" :style="{'cursor':isCursor}">
                    <img src="../../assets/image/icon/excel.png" style="width:2vh;height:2vh;">
                    <span style="font-size:0.8vw;margin-left:0.2vw;top: -0.4vh;">入职导入</span>
                  </p>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <p class="btn-item" @click="downTemp">
                        <img src="../../assets/image/icon/exportAtt.png" style="width:2vh;height:2vh;">
                        <span style="font-size:0.8vw;margin-left:0.2vw;">模板</span>
                      </p>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-upload>
              <el-button type="primary" size="mini" @click="exportWorker" style="margin-left:1vh;">花名册</el-button>
              <el-button type="primary" size="mini" @click="sendSome" :loading="loading1">（旧）批量下发</el-button>
              <el-button type="primary" size="mini" @click="sendAll" :loading="loading1">（旧）一键下发</el-button>
              <!-- <el-button type="primary" size="mini" @click="sendCardNumber" :loading="loading1">下发卡号</el-button> -->
              <el-button type="primary" size="mini" @click="sendCardNumber2" :loading="loading1">（新）下发人员模板
              </el-button>
              <el-button type="primary" size="mini" @click="sendCardNumber3" :loading="loading1">（新）下发离职人员
              </el-button>
              <!-- <el-button type="primary" size="mini" @click="sendCardNumber4" :loading="loading1">下发删除全部人员</el-button> -->
              <el-button type="primary" size="mini" @click="push" :loading="loading2">班组配置</el-button>
              <el-button type="primary" size="mini" @click="outTeam" :loading="loading3">批量出场</el-button>
              <el-button type="primary" size="mini" @click="toAdd">新增</el-button>
            </div>
          </div>
          <div class="build-table">
            <el-table
                stripe
                ref="multipleTable"
                :data="listData"
                style="width: 100%;"
                :show-header="false"
                :default-sort="{prop: 'createDate', order: 'descending'}"
                @selection-change="handleSelectionChange"
            >
              <template slot="empty">
                <p>{{ dataText }}</p>
              </template>
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column width="150">
                <template slot-scope="scope">
                  <div style="display:flex;align-items: center;align-content: center;">
                    <img v-if="scope.row.idcardPhoto!=''" :src="scope.row.idcardPhoto" style="width:3.5vw;height:9vh;"/>
                    <div v-else
                         style="width:3.5vw;height:9vh;background: #ddd;display: flex;align-items: center;justify-content: center;">
                      暂无图片
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <div style="width:100%;height:auto;position: relative;display:flex;justify-content: space-between;">
                    <div style="height:auto;position: relative;width:26%;">
                      <div
                          style="width:100%;height:4vh;position: relative;display:flex;align-content: center;align-items: center;">
                        <a style="font-size: 1vw;color: #3e50b4;width:25%;">{{ scope.row.name }}</a>
                        <p class="nowrap" style="width:8vw;"><span v-if="scope.row.workName&&scope.row.workName!=''"
                                                                   style="padding:2px 1vh;background:#ff9500;color:#fff;border-radius: 2px;font-size:0.6vw;"
                                                                   :title="scope.row.workName">{{
                            scope.row.workName
                          }}</span>
                        </p>
                        <p style="width:2vw;">{{ scope.row.sexName }}</p>
                        <p style="width:3vw;border-left:1px solid #ddd;padding-left: 1vh;">{{ scope.row.age }}岁</p>
                      </div>
                      <div
                          style="width:100%;height:4vh;position: relative;display:flex;align-content: center;align-items: center;">
                        <p style="width:100%;" class=""><span
                            style="color: #3e50b4;">身份证：</span>{{ scope.row.idcard }}</p>
                      </div>
                      <div
                          style="width:100%;height:4vh;position: relative;display:flex;align-content: center;align-items: center;">
                        <p style="width:100%;" class="nowrap" :title="scope.row.address"><span style="color: #3e50b4;">地址：</span>{{
                            scope.row.address
                          }}
                        </p>
                      </div>
                      <div
                          style="width:100%;height:4vh;position: relative;display:flex;align-content: center;align-items: center;">
                        <p style="width:100%;"><span style="color: #3e50b4;">
                          手机号码：</span>{{ scope.row.phone }}
                          <i v-if="isMenuExit('pro:worker:edit')" class="el-icon-edit"
                             style="position: absolute;right: 2vw;color:#409eff;cursor: pointer;top:4px;"
                             @click="modInfo(scope.row)"></i>
                        </p>
                      </div>
                    </div>
                    <div style="height:auto;position: relative;width:25%;">
                      <div
                          style="width:100%;height:4vh;position: relative;display:flex;align-content: center;align-items: center;">
                        <p style="width:100%;" class=""><span
                            style="color: #3e50b4;">参建单位：</span>{{ scope.row.entName }}</p>
                      </div>
                      <div
                          style="width:100%;height:4vh;position: relative;display:flex;align-content: center;align-items: center;">
                        <p style="width:100%;" class=""><span
                            style="color: #3e50b4;">班组：</span>{{ scope.row.teamsName }}</p>
                      </div>
                      <div
                          style="width:100%;height:4vh;position: relative;display:flex;align-content: center;align-items: center;">
                        <p style="width:100%;"><span style="color: #3e50b4;">进场日期：</span>{{ scope.row.inDate }}</p>
                      </div>
                      <div
                          style="width:100%;height:4vh;position: relative;display:flex;align-content: center;align-items: center;">
                        <p style="width:100%;"><span style="color: #3e50b4;">退场日期：</span>{{ scope.row.outDate }}</p>
                      </div>
                    </div>
                    <div style="height:auto;position: relative;width:20%;">
                      <div
                          style="width:100%;height:4vh;position: relative;display:flex;align-content: center;align-items: center;">
                        <p style="width:100%;" class=""><span
                            style="color: #3e50b4;">门禁卡号：</span>{{ scope.row.icCard }}</p>
                      </div>
                      <div
                          style="width:100%;height:4vh;position: relative;display:flex;align-content: center;align-items: center;">
                        <p style="width:100%;" class=""><span :title="scope.row.bankCard"
                                                              style="color: #3e50b4;width:80%;display: inline-block;"
                                                              class="nowrap">银行账户：{{ scope.row.bankCard }}</span>
                          <i v-if="isMenuExit('pro:worker:edit')" class="el-icon-edit"
                             style="position: absolute;top: 4px;right: 2vw;color:#409eff;cursor: pointer;"
                             @click="modInfo(scope.row)"></i>
                        </p>
                      </div>
                      <div
                          style="width:100%;height:4vh;position: relative;display:flex;align-content: center;align-items: center;">
                        <span v-if="scope.row.outFlag=='0'" style="color:#67C23A;">在职</span>
                        <span v-else-if="scope.row.outFlag=='2'">未分配</span>
                        <span v-else style="color:#F56C6C;">离职</span>
                      </div>
                      <!-- <div style="width:100%;height:4vh;position: relative;display:flex;align-content: center;align-items: center;">
                        <p style="width:100%;"><span style="color: #3e50b4;">出勤天数：</span>{{scope.row.sum}}</p>
                      </div> -->
                    </div>
                    <div
                        style="height:auto;position: relative;display: flex;align-items: center;align-content: center;justify-content: flex-end;">
                      <el-button type="success" plain size="mini" @click="sumbitInfo(scope.row)"
                                 style="margin-top:0.5vh;margin-bottom:0.5vh;">个人档案
                      </el-button>
                      <el-button size="mini" @click="personInfo(scope.$index, scope.row)">考勤信息</el-button>
                      <el-button size="mini" v-if="scope.row.outFlag=='0'" type="primary" @click="toUpdate(scope.row)">
                        修改
                      </el-button>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[100,200, 500, 1000]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
            ></el-pagination>
            <!-- 批量下发窗口 -->
            <el-dialog
                title="考勤下发列表"
                :visible.sync="attendVisible"
                center
                :append-to-body="true"
                :lock-scroll="false"
                width="30%"
                :close-on-click-modal="false"
            >
              <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
                <el-tab-pane label="考勤机设备" name="first">
                  <el-table
                      :data="attendData"
                      ref="attendTable"
                      height="300"
                      border
                      style="width: 100%"
                      @selection-change="attendChange"
                  >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="imei" label="考勤机序列号"></el-table-column>
                    <el-table-column label="状态">
                      <template slot-scope="scope">
                        <span>{{ scope.row.statusName }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="特种考勤机" name="second" v-if="search.teamsType=='3'">
                  <el-table
                      :data="attendData1"
                      ref="attendTable1"
                      height="300"
                      border
                      style="width: 100%"
                      @selection-change="attendChange1"
                  >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="imei" label="考勤机序列号"></el-table-column>
                    <el-table-column label="状态">
                      <template slot-scope="scope">
                        <span>{{ scope.row.statusName }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
              <div slot="footer" class="dialog-footer">
                <el-button @click="attendVisible = false">取 消</el-button>
                <el-button type="primary" :loading="loading1" @click="sumbitAttend()">确 定</el-button>
              </div>
            </el-dialog>
            <!-- 下发工资卡 -->
            <el-dialog
                title="考勤下发列表"
                :visible.sync="attendVisible2"
                center
                :append-to-body="true"
                :lock-scroll="false"
                width="30%"
                :close-on-click-modal="false"
            >
              <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
                <el-tab-pane label="考勤机设备" name="first">
                  <el-table
                      :data="attendData"
                      ref="attendTable"
                      height="300"
                      border
                      style="width: 100%"
                      @selection-change="attendChange"
                  >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="imei" label="考勤机序列号"></el-table-column>
                    <el-table-column label="状态">
                      <template slot-scope="scope">
                        <span>{{ scope.row.statusName }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="特种考勤机" name="second" v-if="search.teamsType=='3'">
                  <el-table
                      :data="attendData1"
                      ref="attendTable1"
                      height="300"
                      border
                      style="width: 100%"
                      @selection-change="attendChange1"
                  >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="imei" label="考勤机序列号"></el-table-column>
                    <el-table-column label="状态">
                      <template slot-scope="scope">
                        <span>{{ scope.row.statusName }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
              <div slot="footer" class="dialog-footer">
                <el-button @click="attendVisible2 = false">取 消</el-button>
                <el-button type="primary" :loading="loading1" @click="sumbitAttend2()">确 定</el-button>
              </div>
            </el-dialog>
            <!-- 下发人员模板 -->
            <el-dialog
                title="下发人员模板"
                :visible.sync="attendVisible3"
                center
                :append-to-body="true"
                :lock-scroll="false"
                width="30%"
                :close-on-click-modal="false"
            >
              <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
                <el-tab-pane label="考勤机设备" name="first">
                  <el-table
                      :data="attendData"
                      ref="attendTable"
                      height="300"
                      border
                      style="width: 100%"
                      @selection-change="attendChange"
                  >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="imei" label="考勤机序列号"></el-table-column>
                    <el-table-column label="状态">
                      <template slot-scope="scope">
                        <span>{{ scope.row.statusName }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="特种考勤机" name="second" v-if="search.teamsType=='3'">
                  <el-table
                      :data="attendData1"
                      ref="attendTable1"
                      height="300"
                      border
                      style="width: 100%"
                      @selection-change="attendChange1"
                  >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="imei" label="考勤机序列号"></el-table-column>
                    <el-table-column label="状态">
                      <template slot-scope="scope">
                        <span>{{ scope.row.statusName }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
              <div slot="footer" class="dialog-footer">
                <el-button @click="attendVisible3 = false">取 消</el-button>
                <el-button type="primary" :loading="loading1" @click="sumbitAttend3()">确 定</el-button>
              </div>
            </el-dialog>

            <!-- 下发离职人员 -->
            <el-dialog
                title="下发离职人员"
                :visible.sync="attendVisible4"
                center
                :append-to-body="true"
                :lock-scroll="false"
                width="30%"
                :close-on-click-modal="false"
            >
              <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
                <el-tab-pane label="考勤机设备" name="first">
                  <el-table
                      :data="attendData"
                      ref="attendTable"
                      height="300"
                      border
                      style="width: 100%"
                      @selection-change="attendChange"
                  >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="imei" label="考勤机序列号"></el-table-column>
                    <el-table-column label="状态">
                      <template slot-scope="scope">
                        <span>{{ scope.row.statusName }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="特种考勤机" name="second" v-if="search.teamsType=='3'">
                  <el-table
                      :data="attendData1"
                      ref="attendTable1"
                      height="300"
                      border
                      style="width: 100%"
                      @selection-change="attendChange1"
                  >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="imei" label="考勤机序列号"></el-table-column>
                    <el-table-column label="状态">
                      <template slot-scope="scope">
                        <span>{{ scope.row.statusName }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
              <div slot="footer" class="dialog-footer">
                <el-button @click="attendVisible4 = false">取 消</el-button>
                <el-button type="primary" :loading="loading1" @click="sumbitAttend4()">确 定</el-button>
              </div>
            </el-dialog>

            <!-- 下发删除全部人员 -->
            <el-dialog
                title="下发删除全部人员"
                :visible.sync="attendVisible5"
                center
                :append-to-body="true"
                :lock-scroll="false"
                width="30%"
                :close-on-click-modal="false"
            >
              <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
                <el-tab-pane label="考勤机设备" name="first">
                  <el-table
                      :data="attendData"
                      ref="attendTable"
                      height="300"
                      border
                      style="width: 100%"
                      @selection-change="attendChange"
                  >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="imei" label="考勤机序列号"></el-table-column>
                    <el-table-column label="状态">
                      <template slot-scope="scope">
                        <span>{{ scope.row.statusName }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="特种考勤机" name="second" v-if="search.teamsType=='3'">
                  <el-table
                      :data="attendData1"
                      ref="attendTable1"
                      height="300"
                      border
                      style="width: 100%"
                      @selection-change="attendChange1"
                  >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="imei" label="考勤机序列号"></el-table-column>
                    <el-table-column label="状态">
                      <template slot-scope="scope">
                        <span>{{ scope.row.statusName }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
              <div slot="footer" class="dialog-footer">
                <el-button @click="attendVisible5 = false">取 消</el-button>
                <el-button type="primary" :loading="loading1" @click="sumbitAttend5()">确 定</el-button>
              </div>
            </el-dialog>
            <!-- 班组配置 表格-->
            <el-dialog
                width="30%"
                title="班组配置"
                :append-to-body="true"
                :lock-scroll="false"
                :visible.sync="classVisible"
                :close-on-click-modal="false"
            >
              <el-table :data="classData" height="400" border style="width: 100%">
                <el-table-column label width="55">
                  <template scope="scope">
                    <el-radio
                        :label="scope.row.id"
                        v-model="classId"
                        @change.native="getRadioRow(scope.$index,scope.row)"
                    >{{ '' }}
                    </el-radio>
                  </template>
                </el-table-column>
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="name" label="班组"></el-table-column>
              </el-table>
              <div slot="footer" class="dialog-footer">
                <el-button @click="classVisible = false">取 消</el-button>
                <el-button type="primary" :loading="loading2" @click="sumbitClass()">确 定</el-button>
              </div>
            </el-dialog>
            <!-- 人员修改 -->
            <el-dialog width="500px" title="人员修改" :visible.sync="modifyVisible" :close-on-click-modal="false"
                       append-to-body>
              <el-form
                  :model="workerInfo"
                  ref="workerInfo"
                  label-width="160px"
                  label-position="right"
              >
                <el-form-item label="姓名：">
                  <p>{{ workerInfo.name }}</p>
                </el-form-item>
                <el-form-item label="身份证号：">
                  <p>{{ workerInfo.idcard1 }}</p>
                </el-form-item>
                <el-form-item label="手机号码：">
                  <el-input v-model="workerInfo.phone" autocomplete="off" style="width:10vw;"></el-input>
                </el-form-item>
                <!-- <el-form-item label="门禁卡号：">
                  <el-input v-model="workerInfo.icCard" autocomplete="off" style="width:10vw;"></el-input>
                </el-form-item> -->
                <el-form-item label="银行账户：">
                  <el-input v-model="workerInfo.bankNo" autocomplete="off" style="width:10vw;"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="modifyVisible = false">取 消</el-button>
                <el-button type="primary" @click="modifyWorkerInfo()">确 定</el-button>
              </div>
            </el-dialog>
            <!-- 分配班组成功 -->
            <el-dialog
                :title="dialogTitle1"
                :visible.sync="imoportVisible"
                center
                :append-to-body="true"
                :before-close="handleClose1"
                :lock-scroll="false"
                width="30%"
                :close-on-click-modal="false"
            >
              <template>
                <el-table :data="tableData1" style="width: 100%" border>
                  <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.status==0||scope.row.code==200">
                        <i class="el-icon-circle-check" style="color:#07C160"></i>
                      </span>
                      <span v-if="scope.row.status==1||scope.row.code!=200">
                        <i class="el-icon-warning-outline" style="color:#f00"></i>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="reason" label="原因">
                    <template slot-scope="scope">
                      <span v-if="scope.row.status==0||scope.row.code==200"
                            style="color:#07C160">{{ scope.row.result || scope.row.msg }}</span>
                      <span v-if="scope.row.status==1||scope.row.code!=200"
                            style="color:#f00">{{ scope.row.result || scope.row.msg }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-dialog>
            <!-- 短信弹出框 -->
            <el-dialog
                title="发送内容"
                :visible.sync="messageVisible"
                width="50%"
                class="send"
                :close-on-click-modal="false"
                center>
              <div class="dialog_send">农民工朋友：</div>
              <div class="dialog_send">您好！感谢您为我**项目的辛苦付出，为维护您的合法权益，现温馨提示：</div>
              <div class="dialog_send">
                1.进场后1个月内，须与我单位签订书面劳动合同，明确相应工种、岗位的劳动报酬标准、支付方式等条款。
              </div>
              <div class="dialog_send">
                2.我项目实行实名制管理，按月生成的考勤表经您本人签字确认后，连同每月工资发放表作为您工资发放的依据。
              </div>
              <div class="dialog_send">
                3.您的工资将按月通过委托银行直接打入您的实名制工资卡，请配合项目部统一办理实名制工资卡或提供您的社保卡。实名制工资卡关乎财产安全，请您妥善保管，密码由本人掌握。
              </div>
              <div class="dialog_send">
                4.我项目已设置农民工维权信息告示牌，对您的考勤、工资发放以及专用账户信息等，逐月张贴公示，请注意核对。
              </div>
              <div class="dialog_send">
                如您对我项目工资发放存有异议，请第一时间联系项目部负责人或劳资专管员反映，联系人***，联系电话***。
              </div>
              <div class="dialog_end"> ***项目部</div>
              <div class="dialog_end">2020年*月*日</div>
              <div class="dialog_end else">
                <div>发送人数:{{ number }}人</div>
                <div>
                  <span>短信条数</span>
                  <span style="color:#EA3434">(0.1元/条)</span>
                </div>
                <div><span>合计费用</span><span style="color:#EA3434">{{ money }}元</span></div>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="messageVisible = false">取 消</el-button>
                <el-button type="primary" @click="conmfirm">去支付</el-button>
              </span>
            </el-dialog>
            <!-- 没有专员 -->
            <el-dialog
                :visible.sync="fillVisible"
                width="20%"
                class="send"
                :close-on-click-modal="false"
                center>
              <div style="width:15%;margin:auto">
                <img src="../../assets/image/warning.png" alt="">
              </div>
              <div style="text-align:center">请填写劳资员岗位和联系方式才能发送</div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="fillVisible = false">取 消</el-button>
                <el-button type="danger" plain @click="edit()">去填写</el-button>
              </span>
            </el-dialog>
            <!-- 支付宝页面 -->

            <!-- 上传提示 -->
            <el-dialog title="提示" :visible.sync="tipVis" width="30%" :close-on-click-modal="false">
              <el-table ref="singleTable" :data="tipList" style="width: 100%">
                <el-table-column type="index" label="序号" width="80"></el-table-column>
                <el-table-column property="status" label="状态" width="120">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status=='1'" style="color:#F56C6C;">失败</span>
                    <span v-else-if="scope.row.status=='0'" style="color:#67C23A;">成功</span>
                    <span v-else></span>
                  </template>
                </el-table-column>
                <el-table-column property="reason" label="信息">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status=='1'" style="color:#F56C6C;">{{ scope.row.reason }}</span>
                    <span v-else-if="scope.row.status=='0'" style="color:#67C23A;">{{ scope.row.reason }}</span>
                    <span v-else>{{ scope.row.reason }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-dialog>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'

export default {
  data() {
    return {
      treeId: '',
      listData: [],
      show: true, //展开列表
      search: {
        //查询
        name: '',
        projectId: '',
        idCard: '',
        personStatus: '', // 0-在职；1-离职；2-未入职
        teamsId: '',
        entId: '',
        workType: '',//工种或者岗位或者特殊工种
        teamsType: '', //班组类型 工人/管理人员/特殊工种
        sort: '0',
      },
      date: '',
      dataText: '数据加载中...',
      dataTree: [], //树形列表
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      attendVisible: false, //考勤机弹出框
      attendVisible2: false,
      attendVisible3: false,//下发人员模板
      attendVisible4: false,//下发离职人员
      attendVisible5: false,
      attendData: [], //考勤设备列表（非特种考勤机）
      attendData1: [],//考勤设备列表（特种考勤机）
      activeName: 'first',

      classVisible: false, //班组弹出框
      classData: [], //班组数据
      classId: '', //班组id
      attendSel: [], //考勤机选择
      personIdStr: '', //人员选择（下发）
      ids: '', //人员信息id（班组配置）
      personIdClass: '', //人员选择(班组配置)
      dataText: '数据加载中...',
      dialogTitle1: '配置结果',
      statusper: [
        {label: '在职', value: '0'},
        {label: '离职', value: '1'}
        // { label: '未入职', value: '2' }
      ], //筛选人员状态
      personStu: '0',
      Phone: [],
      modifyVisible: false,
      imoportVisible: false,
      workerInfo: {
        id: '',
        name: '',
        idcard: '',
        phone: '',
        idcard1: '',
        bankNo: ''
      },
      typeNameAll: [], //考勤机类型字典表
      workerType: [], //工种列表
      managerType: [],//岗位列表
      tableData1: [],
      messageVisible: false, //发送短信弹出框
      fillVisible: false,//无联系
      zfbVisible: false,
      selsectPerson: [],
      number: '',
      money: '',
      address: '',
      phone1: '',
      // eduList:[],//教育类型
      specialType: [],//特殊工种
      currentNodekey: '', //默认选中的节点树
      expandedkeys: [], //默认展开的节点树

      isIndeterminate: false,
      checkAll: false,
      //导入
      uploadUrl: myHttp.importTeamsPersonExcel,
      uploadHead: {
        accessToken: util.session.get('token')
      },
      uploadData: {
        teamsId: '',
        projectId: '',
      },
      tipVis: false,
      tipList: [],
      //判断操作是否进行中
      loading1: false, //批量下发
      loading2: false,//批量班组配置
      loading3: false,//批量出场

      //删除状态
      isCursor: 'pointer',//wait
      //分页
      currentPage: 1,
      pageSize: 100,
      totalItems: 0,
    }
  },
  created() {
    this.search.projectId = util.session.get('groupId')
    const {treeId} = this.$route.query
    console.log(treeId);
    this.treeId = treeId
  },
  mounted() {
    this.search.projectId = util.session.get('groupId')
    if (this.search.projectId == '') {
      this.$store.commit('setGroupId')
      this.search.projectId = this.$store.state.groupId
    }
    // this.getData()
    this.getDict()
    // this.getAttendList()
    this.getClass()
    this.getTypeDict('position') //获取岗位
    this.getTypeDict('worktype') //获取工种
    this.getSpeDict() //
    this.teamTree() //获取组织树
  },
  methods: {
    // 搜索数据
    doFilter(index) {
      // this.search.personStatus = index
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      if (this.treeId) {
        this.search.teamsId = this.treeId
        this.search.entId = ''
      }
      that.dataText = '数据加载中...'
      this.listData = []
      this.search.pageNum = this.currentPage
      this.search.pageSize = this.pageSize
      myHttp.getProjectPersonManagerPage(this.search).then(
          function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.list.list || []
              for (var i = 0; i < list.length; i++) {
                list[i].idcardPhoto = list[i].idcardPhoto && list[i].idcardPhoto != '' ? base.httpCtx + list[i].idcardPhoto : ''
                list[i].createDate = list[i].createDate && list[i].createDate != '' ? list[i].createDate.split(' ')[0] : ''
                list[i].age = util.myTime.getAge(list[i].birthday)
                if (list[i].sex == '1') {
                  list[i].sexName = '男'
                } else if (list[i].sex == '2') {
                  list[i].sexName = '女'
                } else {
                  list[i].sexName = ''
                }
                list[i].yearLen = list[i].createDate && list[i].createDate != '' ? util.myTime.getYearLen(list[i].createDate) : 1
                list[i].inDate = list[i].createDate && list[i].createDate != '' ? util.myTime.formatTime(list[i].createDate, 'YYYY年MM月dd日') : ''
                if (list[i].outFlag != '0') {
                  list[i].outDate = list[i].updateDate && list[i].updateDate != '' ? util.myTime.formatTime(list[i].updateDate, 'YYYY年MM月dd日') : ''
                } else {
                  list[i].outDate = ''
                }
                that.listData.push(list[i])
                that.totalItems = resp.data.data.list.total || 0
              }
              // that.listData = list
              that.getTypeName()
              if (that.listData.length == 0) {
                that.dataText = '暂无数据'
              }
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          },
          function () {
          }
      )
    },
    //获取考勤机
    getAttendList() {
      var that = this
      myHttp
          .getRecogByProjectId1({
            projectId: this.search.projectId
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.pageInfo || []
              that.attendData = []
              that.attendData1 = []
              for (var i = 0; i < list.length; i++) {
                list[i].statusName = that.filterSatus(list[i].status)
                if (list[i].status == '5') {
                  that.attendData1.push(list[i])
                } else {
                  that.attendData.push(list[i])
                }
              }
              // that.attendData = list
            }
          })
    },
    //获取类型
    filterSatus(str) {
      var list = this.typeNameAll
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (str == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
    //获取班组
    getClass() {
      var that = this
      myHttp
          .getTeams1({
            projectId: this.search.projectId
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.classData = resp.data.data.pageInfo || []
            }
          })
    },
    //人员表格选择
    handleSelectionChange(val) {
      this.selsectPerson = val
      this.personIdStr = ''
      this.phone1 = ''
      this.personIdClass = ''
      this.ids = ''
      this.phone = []
      if (val.length > 0) {
        for (var i = 0; i < val.length; i++) {
          if (i == 0) {
            this.personIdStr = val[i].personId
            this.phone1 = val[i].phone
          } else {
            this.personIdStr += ',' + val[i].personId
            this.phone1 += ',' + val[i].phone
          }
          //班组配置人员
          if (undefined == val[i].teamsName ||
              '' == val[i].teamsName ||
              '0' != val[i].outFlag
          ) {
            if (this.personIdClass == '') {
              this.personIdClass = val[i].personId
            } else {
              this.personIdClass += ',' + val[i].personId
            }
            if (this.ids == '') {
              this.ids = val[i].id
            } else {
              this.ids += ',' + val[i].id
            }
          }
          this.phone = val
        }
      }
      console.log(this.ids)
    },
    //考勤机表格选择
    attendChange(val) {
      for (var i = 0; i < val.length; i++) {
        if (i == 0) {
          this.attendSel = val[i].imei
        } else {
          this.attendSel += ',' + val[i].imei
        }
      }
    },
    attendChange1(val) {
      for (var i = 0; i < val.length; i++) {
        if (i == 0) {
          this.attendSel = val[i].imei
        } else {
          this.attendSel += ',' + val[i].imei
        }
      }
    },
    //考勤选择后点击确认
    sumbitAttend() {
      var that = this
      if (this.personIdStr != '') {
        if (this.personIdStr == '' || this.attendSel == '') {
          that.$message.error('请选择下发人员或设备！')
          return
        }
        this.loading1 = true
        myHttp
            .downWorker({
              personIdStr: this.personIdStr,
              machineIdStr: this.attendSel
            })
            .then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('下发成功')
                that.attendVisible = false
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
              that.loading1 = false
            }, function () {
              that.loading1 = false
            })
      } else {
        myHttp
            .issueCmdBatch({
              machineIds: this.attendSel,
              projectId: util.session.get('groupId'),
              personStatus: this.search.personStatus,
              name: this.search.name,
              idCard: this.search.idCard,
              teamsId: this.search.teamsId,
              entId: this.search.entId,
              workType: this.search.workType,
              teamsType: this.search.teamsType,
              sort: this.search.sort
            })
            .then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('下发成功')
                that.attendVisible = false
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
              that.loading1 = false
            }, function () {
              that.loading1 = false
            })


      }

    },
    //班组选择
    getRadioRow(index, row) {
    },
    //班组配置
    sumbitClass: function () {
      var that = this
      for (var i = 0; i < this.phone.length; i++) {
        if (this.phone[i].phone == '' || undefined == this.phone[i].phone) {
          that.$message.error('请到个人档案完善手机号！')
          return
        }
      }
      this.loading2 = true
      myHttp
          .joinTeamsBatchNow({
            teamsId: this.classId,
            personIdStr: this.personIdStr,
            idStr: this.ids,
            operationPerson: util.session.get('user').id,
            projectId: util.session.get('groupId')
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.tableData1 = resp.data.data.List || []
              that.classVisible = false
              that.getData()
              that.imoportVisible = true
              // for(var i = 0;i<that.tableData1.length;i++){
              //   if(that.tableData1[i].status==0){
              //     that.$message.success(that.tableData1[i].result)
              //   }else{
              //     that.$message.error(that.tableData1[i].result)
              //   }
              // }
            } else {
              that.$message.error(resp.data.msg)
            }
            that.loading2 = false
          }, function () {
            that.loading2 = false
          })
    },
    //个人档案
    sumbitInfo(row) {
      var id = row.personId
      this.$router.push({
        name: 'perFile',
        params: {id: id, groupId: this.search.projectId, treeId: this.treeId, type: 1}
      })
    },
    //考勤详情
    personInfo(index, row) {
      var id = row.personId
      this.$router.push({name: 'workerInfo', params: {id: row.personId, treeId: this.treeId, type: 1}})
    },
    // 改变人员状态
    filterName1(e) {
      this.search.personStatus = e
      this.getData()
    },
    //修改人员信息
    modInfo(row) {
      this.modifyVisible = true
      var that = this
      myHttp
          .getPersonInfoById({
            id: row.personId
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              var data = resp.data.data.person
              that.workerInfo = {
                id: data.id,
                name: data.name,
                idcard1: row.idcard,
                idcard: data.idcard,
                icCard: data.icCard,
                phone: data.phone,
                bankNo: data.bankNo
              }
            } else {
              that.$message.success(resp.data.msg)
            }
          })
    },
    //提交修改信息
    modifyWorkerInfo() {
      var that = this
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.workerInfo.phone)) {
        this.$message.success('请输入正确的手机号')
        return;
      }
      delete this.workerInfo.idcard1
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.workerInfo.phone)) {
        this.$message.success('请输入正确的手机号')
        return;
      }
      myHttp.modProjectPerson({
        projectId: this.search.projectId,
        ...this.workerInfo
      }).then(function (resp) {
        if (resp.data.code == '200') {
          that.$message.success('修改成功')
          that.modifyVisible = false
          that.getData()
        } else {
          that.$message.success(resp.data.msg)
        }
      })
    },
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //   this.currentPage = val
    //   this.currentChangePage()
    // },
    // 监控当前页码
    // currentChangePage(list) {
    //   this.getData()
    // }
    exportWorker() {
      var token = util.session.get('token')
      window.open(
          myHttp.exportTeamsPersons +
          '?projectId=' +
          this.search.projectId +
          '&personStatus=' +
          this.search.personStatus +
          '&teamName=' +
          this.search.teamName +
          '&name=' +
          this.search.name +
          '&accessToken=' +
          token
      )
    },
    //字典表（考勤机类型）
    getDict() {
      var that = this
      myHttp
          .getDictByType({
            type: 'attend_type'
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.typeNameAll = resp.data.data.dictList
              that.getAttendList()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
    },
    //获取字典类型
    getTypeDict(type) {
      var that = this
      myHttp
          .getDictByType({
            type: type
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              if (type == 'position') {
                that.managerType = resp.data.data.dictList
              } else {
                that.workerType = resp.data.data.dictList
              }
              that.getTypeName()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
    },
    //展示工种或者岗位
    getTypeName() {
      //var list = this.listData
      if (this.listData.length == 0) {
        return
      }
      for (var i = 0; i < this.listData.length; i++) {
        if (this.listData[i].teamsType == '1') {
          this.listData[i].typeName = this.getNameById(
              this.listData[i].teamsWork,
              this.workerType
          )
        } else {
          this.listData[i].typeName = this.getNameById(
              this.listData[i].teamsWork,
              this.managerType
          )
        }
      }
    },
    //获取数据名称
    getNameById(id, list) {
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
    //点击树形结构
    handleNodeClick(data) {
      // console.log(data)
      this.treeId = data.id
      if (data.type == '1') {
        this.search.entId = data.parentId
        this.search.teamsId = ''
        this.search.teamsType = ''
        this.search.workType = ''
      } else if (data.type == '0') {
        this.search.entId = ''
        if (this.search.teamsId != data.id) {
          this.search.workType = ''
        }
        this.search.teamsId = data.id
        this.search.teamsType = data.teamsType
      } else {
        this.search.entId = ''
        this.search.teamsId = ''
        this.search.teamsType = ''
        this.search.workType = ''
      }
      // if (data.status == '2') {
      //   this.search.personStatus = '2'
      // } else {
      //   this.search.personStatus = this.personStu
      // }
      this.getData()
    },
    //获取树形结构
    teamTree() {
      var that = this
      myHttp
          .getEntTeams({
            projectId: this.search.projectId
          })
          .then(function (resp) {
            //console.log(resp)
            if (resp.data.code == '200') {
              var list = resp.data.data.list || []
              var tree = util.common.listToTree('id', 'parentId', list)
              var obj = [{name: '全部', id: '', parentId: '', children: []}]

              obj[0].children = tree
              that.dataTree = obj
              var curKey = ''
              if (list.length > 0) {
                curKey = tree[0].id
                that.search.entId = tree[0].parentId
                that.search.teamsId = ''
                that.search.teamsType = ''
                that.search.workType = ''
              }
              if (that.treeId) {
                setTimeout(function () {
                  that.$refs.tree.setCurrentKey(that.treeId)
                }, 100)
              } else {
                setTimeout(function () {
                  that.$refs.tree.setCurrentKey(curKey)
                }, 100)
              }

              if (curKey != '') {
                that.getData()
              } else {
                that.dataText = '暂无数据'
              }
            } else {
              that.dataText = '暂无数据'
            }
          })
    },
    watchInput(e) {
      // console.log(e)
      this.search.personStatus = e
      this.getData()
    },
    push() {
      if (this.selsectPerson.length != 0) {
        this.classVisible = true
        this.getClass()
      } else {
        this.$message.warning('请选择人员')
        return
      }
    },
    /**
     * 批量下发
     */
    sendSome() {
      // this.selsectPerson
      this.activeName = 'first'
      if (this.selsectPerson.length != 0) {
        this.attendVisible = true
      } else {
        this.$message.warning('请选择需要下发的人员')
        return
      }
    },
    sendAll() {
      this.attendVisible = true
    },
    //  下发卡号
    sendCardNumber() {
      if (this.selsectPerson.length != 0) {
        this.attendVisible2 = true
      } else {
        this.$message.warning('请选择需要下发的人员')
        return
      }
    },
    // 下发人员模板
    sendCardNumber2() {
      if (this.selsectPerson.length != 0) {
        this.attendVisible3 = true
      } else {
        this.$message.warning('请选择需要下发的人员')
        return
      }
    },
    // 下发离职人员
    sendCardNumber3() {
      if (this.selsectPerson.length != 0) {
        this.attendVisible4 = true
      } else {
        this.$message.warning('请选择需要下发的人员')
        return
      }
    },
    sendCardNumber4() {
      if (this.selsectPerson.length != 0) {
        this.attendVisible5 = true
      } else {
        this.$message.warning('请选择需要下发的人员')
        return
      }
    },
    sumbitAttend2() {
      if (this.personIdStr != '') {
        if (this.personIdStr == '' || this.attendSel == '') {
          this.$message.error('请选择下发人员或设备！')
          return
        }
        myHttp.downloadPersonIdcard({
          personIdStr: this.personIdStr,
          machineIdStr: this.attendSel
        }).then(resp => {
          if (resp.data.code == '200') {
            this.$message.success('下发成功')
            this.attendVisible2 = false
            this.getData()
          } else {
            this.$message.error(resp.data.msg)
          }
        })
      }
    },
    sumbitAttend3() {
      if (this.personIdStr != '') {
        if (this.personIdStr == '' || this.attendSel == '') {
          this.$message.error('请选择下发人员或设备！')
          return
        }
        myHttp.downloadPersonTemplate({
          personIdStr: this.personIdStr,
          machineIdStr: this.attendSel
        }).then(resp => {
          if (resp.data.code == '200') {
            this.$message.success('下发人员模板成功')
            this.attendVisible3 = false
            this.getData()
          } else {
            this.$message.error(resp.data.msg)
          }
        })
      }
    },
    sumbitAttend4() {
      if (this.personIdStr != '') {
        if (this.personIdStr == '' || this.attendSel == '') {
          this.$message.error('请选择下发人员或设备！')
          return
        }
        myHttp.downloadDeparturePerson({
          personIdStr: this.personIdStr,
          machineIdStr: this.attendSel
        }).then(resp => {
          if (resp.data.code == '200') {
            this.$message.success('下发离职人员成功')
            this.attendVisible4 = false
            this.getData()
          } else {
            this.$message.error(resp.data.msg)
          }
        })
      }
    },
    sumbitAttend5() {
      if (this.personIdStr != '') {
        if (this.personIdStr == '' || this.attendSel == '') {
          this.$message.error('请选择下发人员或设备！')
          return
        }
        myHttp.downloadDelAllPerson({
          personIdStr: this.personIdStr,
          machineIdStr: this.attendSel
        }).then(resp => {
          if (resp.data.code == '200') {
            this.$message.success('下发删除全部人员成功')
            this.attendVisible5 = false
            this.getData()
          } else {
            this.$message.error(resp.data.msg)
          }
        })
      }
    },
    exportWorker() {
      var token = util.session.get('token')
      window.open(
          myHttp.exportTeamsPersons +
          '?projectId=' +
          this.search.projectId +
          '&personStatus=' +
          this.search.personStatus +
          '&teamsId=' +
          this.search.teamsId +
          '&name=' +
          this.search.name +
          '&accessToken=' +
          token
      )
    },
    handleClose1(done) {
      this.imoportVisible = false
    },
    //批量出场
    outTeam() {
      var that = this
      if (this.personIdStr == '') {
        that.$message.error('请选择工人！')
        return
      }
      this.$confirm('确认工人离场吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading3 = true
        myHttp.outTeamsBatchByProjectId({
          idStr: that.personIdStr,
          projectId: that.search.projectId,
          operationPerson: util.session.get('user').id
        }).then(function (resp) {
          if (resp.data.code == '200') {
            that.$message.success('离场成功')
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
          that.loading3 = false
        }, function () {
          that.loading3 = false
        })
      })
    },
    //个人离场
    handleDelete(index, row) {
      var that = this
      this.$confirm('确认该人员（' + row.name + '）离场吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.outTeamsBatch({
          idStr: row.personId,
          teamsId: row.teamsId,
          operationPerson: util.session.get('user').id
        }).then(function (resp) {
          if (resp.data.code == '200') {
            that.$message.success('离场成功')
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      })
    },
    /**
     * 判断是否展示
     */
    isMenuExit(row) {
      var flag = util.common.filterBtnMenu(row)
      return flag
    },
    // 发送短信
    sendMessage() {
      // 判断是否有劳资专管员或者项目经理的手机号码
      var that = this
      // judgePhone
      myHttp
          .judgePhone({
            // projectId: this.search.projectId
            projectId: '1175661048930197506'
          })
          .then(function (resp) {
            //console.log(resp)
            if (resp.data.code == '200') {
              // console.log(resp)
              var number = that.selsectPerson.length
              that.number = number
              if (number == 0) {
                that.$message.error("请选择人员")
                return
              }

              that.messageVisible = true

              // console.log(number)
              that.setMoney(number)
            } else {
              that.fillVisible = true
            }
          })
    },
    // 计算金额
    setMoney(number) {
      var that = this
      myHttp
          .paymentAmount({
            number: number
          })
          .then(function (resp) {
            //console.log(resp)
            if (resp.data.code == '200') {
              that.money = resp.data.data.pageInfo.money
            } else {
              that.$message.error(resp.data.msg)
            }
          })
    },
    randomWord(randomFlag, min, max) {
      var str = ''
      range = min,
          arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];
      //随机产生
      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min;
      }
      for (var i = 0; i < range; i++) {
        var pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos]
      }
      return str;
    },

    // 挑战班组页面
    edit() {
      this.$router.push({path: '/teamMan'})
    },
    conmfirm() {
      // send
      var that = this
      var subject = this.randomWord(false, 32)
      myHttp
          .send({
            money: this.money,
            subject: subject
          })
          .then(function (resp) {
            that.address = resp.data
            if (resp.data) {
              //打开新页面
              let routerData = that.$router.resolve({path: '/applyText', query: {htmls: resp.data}})
              window.open(routerData.href, '_ blank')
              const div = document.createElement('div');
              div.innerHTML = htmls;
              document.body.appendChild((div),
                  document.forms [0].submit())
            } else {
              that.$message.error(resp.data.msg)
            }
          })
    },
    // 测试发送短信
    test() {
      var that = this
      myHttp
          .sendMessages({
            projectId: this.search.projectId,
            phone: this.phone1
          })
          .then(function (resp) {
            //console.log(resp)
            if (resp.data.code == '200') {
              that.money = resp.data.data.pageInfo.money
            } else {
              that.$message.error(resp.data.msg)
            }
          })

    },

    //获取特殊工种
    getSpeDict() {
      var that = this
      myHttp.getDictByType({
        type: 'special_type'
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.dictList
          that.specialType = list
        }
      })
    },
    /**
     * 获取教育字典表
     */
    // getEduDict(){
    //   var that = this
    //   myHttp.getDictByType({
    //       type: 'edu_type'
    //   }).then(function(resp) {
    //     if (resp.data.code == '200') {
    //       var　list = resp.data.data.dictList
    //       that.eduList = list
    //     }
    //   })
    // },
    // getEduName(id){
    //   var result = ''
    //   for(var i=0;i<this.eduList.length;i++){
    //     if(id==this.eduList[i].value){
    //       result = this.eduList[i].label
    //     }
    //   }
    //   return result
    // },

    /**
     * 添加人员
     */
    toAdd() {
      this.$router.push({path: '/workerAdd/0'})
    },
    /**
     * 修改
     */
    toUpdate(row) {
      this.$router.push({path: '/workerAdd/' + row.personId})
    },

    //选择工种或者岗位
    subWorkType(item) {
      this.search.workType = item.value
      this.getData()
    },
    //选择状态
    statusSearch(index) {
      this.search.personStatus = index ? index : ''
      if (index == '2') {
        this.search.entId = ''
        this.search.teamsId = ''
        this.search.teamsType = ''
        this.search.workType = ''
        var that = this
        setTimeout(function () {
          that.$refs.tree.setCurrentKey(undefined)
        }, 100)
      } else {
        this.search.teamName = ''
      }
      this.getData()
    },


    //全选
    handleCheckAllChange(rows) {
      // console.log(this.checkAll)
      if (this.checkAll) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
      this.isIndeterminate = false;
    },

    //上传前
    beforeAvatarUpload(file) {
      this.uploadData.teamsId = this.search.teamsId
      this.uploadData.projectId = util.session.get('groupId')
      this.isCursor = 'wait'
    },
    //上传结果
    handleAvatarSuccess(res, file) {
      if (res.code == '200') {
        this.getData()
        this.dialogUpload = false
        this.tipVis = true
        this.tipList = res.data.list || []
      } else {
        this.$message.error(resp.msg)
      }
      this.isCursor = 'pointer'
    },

    /**
     * 导入
     */
    downTemp() {
      window.open(myHttp.exportModelExcel + '?accessToken=' + util.session.get('token'))
    },

    /**
     * 切换tab
     */
    tabClick(tab, e) {
      if (tab.index == '0') {
        if (this.attendSel != '') {
          this.$refs.attendTable1.clearSelection();
        }
        this.attendSel = ''
      } else {
        if (this.attendSel != '') {
          this.$refs.attendTable.clearSelection();
        }
        this.attendSel = ''
      }
    },

  }
}
</script>
<style>
@import '../../assets/css/common.css';

.build-table .el-table__empty-text p {
  text-align: center;
}
</style>
<style scoped>
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}

.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
}

.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}

.build-table {
  /* height: calc(100% - 80px); */
  width: 100%;
  height: auto;
}

.cur {
  background: #ECF5FF !important;
  color: #409EFF !important;
}

div >>> .el-dialog__header {
  padding: 20px 20px 10px;
  text-align: center !important;
}

.send >>> .el-dialog__header {
  text-align: left !important;
}

div >>> .el-dialog__footer {
  padding: 10px 20px 20px;
  text-align: center;
  box-sizing: border-box;
}

div >>> .el-input-group--append .el-input__inner {
  width: 200px;
}

.dialog_send {
  margin: 10px 0px 10px 35px;
}

.dialog_end {
  padding: 30px 0px 10px 35px;
  display: flex;
  justify-content: flex-end;
}

.else {
  justify-content: space-between;
  border-top: 1px dotted #ECF5FF;
}

.tips {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
}

.build-table * {
  text-align: left;
  font-size: 0.8vw;
}

.type-item {
  color: #3e50b4;
  margin: 0 0.5vh 0.5vh 0;
  font-size: 0.8vw;
  cursor: pointer;
  height: 3vh;
  line-height: 3vh;
  padding: 0 1vh;
  border-radius: 2px;
}

.type-item:hover {
  color: #409eff;
}

.selIndex {
  background: #409eff;
  color: #fff;
}

.selIndex:hover {
  color: #fff;
}

.gongzhong {
  width: 100%;
  height: 6vh;
  position: relative;
  border-bottom: 1px dashed rgb(239 233 233);
  overflow: hidden;
  /* display:flex;align-items: center; */
}

.gzAuto {
  height: auto;
}

.self-btn {
  padding: 4px 15px;
  font-size: 12px;
  position: relative;
  border: 1px solid #707070;
  border-radius: 3px;
  color: #409EFF;
  display: inline-block;
  margin-right: 1vh;
  top: 3px;
  cursor: pointer;
}

.self-btn img {
  width: 16px;
  height: 16px;
  top: 3px;
  margin-left: 2px;
}
</style>
